import { Organization } from 'types/organization.type';
import { BaseActiveProducer } from 'helpers/ActiveUserProducer/BaseActiveProducer';
import { Link } from '@mui/material';
import * as React from 'react';
import { ReactFragment } from 'react';

export class SupportActiveProducer extends BaseActiveProducer {
    getCreateSubmissionSubHeader(assignedProducer: Organization, doSelectProducer: () => void): ReactFragment {
        if (!assignedProducer) {
            return (
                <>
                    <Link
                        href="#"
                        onClick={() => {
                            doSelectProducer();
                        }}
                        underline="hover"
                    >
                        Select Producer Context
                    </Link>
                </>
            );
        }
        return super.getCreateSubmissionSubHeader(assignedProducer, doSelectProducer);
    }

    validateAssignedProducer(assignedProducer: Organization): Organization | undefined {
        if (assignedProducer) {
            const foundProducer = this.availableProducers.find((p) => p.id === assignedProducer.id);
            if (foundProducer) {
                return foundProducer;
            }
        }
        return undefined;
    }
}
